import React from 'react';
import { Box, useMediaQuery, useTheme, CircularProgress, FormControl } from '@material-ui/core';
import { OptionsType } from 'react-select';
import { useIntl } from 'react-intl';
import { StepButtonBar } from '../OtherRequirementWizard/StepButtonBar';
import { StepProps } from './types';
import { Select } from '../../../../../Components';
import { SelectOption } from '../../../../../Components/Form/Form.types';
import UpdateConnectionInfo from './UpdateConnectionInfo';
import { useFetchSelectOptions } from '../../../../../Api';
import { useAptorApi } from '../../../../../Api';

interface Step6EditCompanyUnitUsersProps extends StepProps {
  selectedUsers: SelectOption[];
  onSelectedUsersChange: (users: SelectOption[]) => void;
  users?: OptionsType<SelectOption> | null;
  selectedUnitId?: number;
  currentStepName: string;
  updateConnectionInfo: any;
  setUpdateConnectionInfo: (info: any) => void;
}

const Step6EditCompanyUnitUsers = ({
  onNext,
  onBack,
  onCancel,
  isFirstStep,
  selectedUsers,
  onSelectedUsersChange,
  selectedUnitId,
  currentStepName,
    updateConnectionInfo,
  setUpdateConnectionInfo,
}: Step6EditCompanyUnitUsersProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);
  const { api, abortController } = useAptorApi();

  // Fetch users if selectedUnitId is provided and users not passed as prop
  const [fetchedUsers] = useFetchSelectOptions(
    React.useCallback(
      () => selectedUnitId ? api.getCustomerCompanyUnitUsers(selectedUnitId) : Promise.resolve({ items: [] }),
      [selectedUnitId, api]
    ),
    abortController
  );

  const users =  fetchedUsers;

  if (!users) {
    return (
      <Box style={{ display: 'flex', justifyContent: 'center', padding: theme.spacing(4) }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
      <div style={{ width: '100%' }}>
          <div
            style={{
              display: 'flex',
              width: '100%',
              gap: '10px',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: 'stretch',
            }}
          >
            <div
              style={{
                width: isMobile ? '100%' : 'calc(50% - 5px)',
                flexShrink: 0,
                padding: paperPadding,
                backgroundColor: '#f7f0f1',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '350px',
              }}
            >
              <Box style={{ maxWidth: '320px', width: '100%' }}>
                 {/* <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: theme.spacing(1) }}>
            {formatMessage({ id: 'law-portal.manage.edit-law.complianceUsers' })}
          </Typography> */}
          <FormControl style={{ width: '100%' }}>
            <Select
              selectProps={{
                options: users,
                value: selectedUsers,
                onChange: (val: any) => onSelectedUsersChange(val || []),
                placeholder: formatMessage({ id: 'law-portal.manage.edit-law.complianceUsers' }),
                isMulti: true,
                isClearable: true,
              }}
            />
          </FormControl>
              </Box>
            </div>
            <UpdateConnectionInfo
              updateConnectionInfo={updateConnectionInfo}
              currentStepName={currentStepName}
              onUpdate={setUpdateConnectionInfo}
            />
          </div>
    
          <Box>
               <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={onNext}
          nextLabel="form.next"
          formatMessage={formatMessage}
          showBack={!isFirstStep}
        />
          </Box>
        </div>
  );
};
export default Step6EditCompanyUnitUsers;